module.exports = __webpack_public_path__ + "static/media/Eat.b2bdbecd.jpg";